import React from "react";
import { motion } from "framer-motion";

const VisionStatement: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center gap-4 py-10 px-3 md:px-24 bg-backgroundColor">
      <motion.h2
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="font-CrimsonText font-bold text-xl md:text-2xl text-primaryColor text-center underline"
      >
        Vision Statement
      </motion.h2>
      <motion.p
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.3 }}
        viewport={{ once: true }}
        className="font-CrimsonText font-normal text-base leading-5 md:text-xl text-textColor text-center"
      >
        ECOCYNTEC Limited's vision is to be the global leader in energy and data
        center engineering, setting the standard for exceptional quality and
        client satisfaction. We strive to be the preferred partner by
        consistently delivering innovative, sustainable, and high-performance
        solutions—from optimizing upstream oil and gas operations to deploying
        advanced data center thermal management systems. By upholding our
        commitment to customer centricity, integrity, and consistent results, we
        will foster a culture of excellence, drive industry advancements, and
        build enduring partnerships across both the energy and data center
        landscapes.
      </motion.p>
    </div>
  );
};

export default VisionStatement;
